import { horizontalSpacing, verticalSpacing } from '../constants/style-constants';

export const unit = (multiplier = 1, spacing) => `${multiplier * spacing.value}${spacing.unit}`;
export const hunit = multiplier => unit(multiplier, horizontalSpacing);
export const vunit = multiplier => unit(multiplier, verticalSpacing);
